import React from 'react';
import { FlaskConicalIcon } from 'lucide-react';
export function ExampleBadge() {
  return <span className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-flame-100 px-3 py-1 text-xs font-extrabold text-flame-700" data-id="element-52" data-mp="65vqjh9in612">
      <FlaskConicalIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-53" data-mp="az70vsdje4xq" />
      EXAMPLE data
    </span>;
}